module.exports = __webpack_public_path__ + "img/winner.8381d792.png";